/* generated by pull.js */
const manifest = {
    "editorOnly": true,
    "name": "Stage Camera Control",
    "description": "Adds camera controls to the Stage, supporting zoom, pan, and full-screen modes. This is particularly useful when using the Video Sensing or Face Detection extensions.",
    "credits": [
        {
            "name": "笑小朗"
        }
    ],
    "userscripts": [
        {
            "url": "userscript.js",
            "matches": ["projects"]
        }
    ],
    "userstyles": [
        {
            "url": "style.css",
            "matches": ["projects"]
        }
    ],
    "settings": [
        {
            "name": "Show Controls",
            "id": "showControls",
            "type": "boolean",
            "default": false
        },
        {
            "name": "Auto-Hide",
            "id": "autoHide",
            "type": "boolean",
            "default": false
        }
    ],
    "tags": ["editor", "stage", "rw", "new"],
    "enabledByDefault": false
};

export default manifest;
